<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Set up automated publishing and streamline your release process'
    "
    [icon]="'@tui.route'"
    [subtitle]="'How it works'"
    [title]="'Get started in 3 simple steps'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
    <div
      class="flex flex-1 flex-col justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <span class="text-xl font-bold md:text-2xl"
        >1. Connect your Git repository</span
      >
      <p class="text-pretty text-lg">
        Connect your repository to Capawesome Cloud and enable automatic builds
        with Native Builds for a complete CI/CD pipeline.
      </p>
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="consoleBaseUrl"
        target="_blank"
        data-umami-event="app-store-publishing-how-it-works-get-started-button"
      >
        Get started
      </a>
    </div>
    <div
      class="flex flex-1 flex-col justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <span class="text-xl font-bold md:text-2xl"
        >2. Configure the app stores</span
      >
      <p class="text-pretty text-lg">
        Set up your App Store Connect and Google Play Console credentials.
        Configure which tracks and destinations to publish to.
      </p>
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="docsUrl"
        target="_blank"
        data-umami-event="app-store-publishing-how-it-works-configure-button"
      >
        Read the docs
      </a>
    </div>
    <div
      class="flex flex-1 flex-col justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <span class="text-xl font-bold md:text-2xl"
        >3. Start publishing your app</span
      >
      <p class="text-pretty text-lg">
        Publish with a single click or automatically after successful builds.
        Your apps are submitted to TestFlight and store tracks instantly.
      </p>
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="docsUrl"
        target="_blank"
        data-umami-event="app-store-publishing-how-it-works-publish-button"
      >
        Read the docs
      </a>
    </div>
  </div>
</section>
